import { FormlyFieldConfig } from 'ng-formly';
import { ValidationService } from '../services/validation.service';
import { Validators } from "@angular/forms";
export const accountfields: Array<FormlyFieldConfig> = [
    {
        key: 'email',
        type: 'input-field',
        className: 'col-md-4',
        templateOptions: {
            type: 'email',
            label: 'Email address',
            placeholder: 'Enter email',
            disabled: true
        },
        validation: Validators.compose([Validators.required, ValidationService.emailValidator]),
        expressionProperties: {
            'templateOptions.disabled': 'model.id'
        }
    },
    {
        key: 'password',
        type: 'input-field',
        className: 'col-md-4',
        templateOptions: {
            type: 'password',
            label: 'Password',
            placeholder: 'Password'
        },
        validation: Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(6)]),
        expressionProperties: {
            'templateOptions.disabled': 'model.id'
        }
    },
    {
        key: 'status',
        type: 'select-component',
        className: 'col-md-4',
        defaultValue: 'Active',
        hideExpression: "!model.email && !model.password",
        templateOptions: {
            options: [{
                label: 'Active',
                value: 'Active'
            }, {
                label: 'Inactive',
                value: 'Inactive'
            }],
            label: 'Status',
            placeholder: 'Select Status'
        }
    },
    {
        className: 'col-md-12',
        template: '<br/><hr/>'
    },
    {
        key: 'accounttype',
        type: 'select-component',
        className: 'col-md-4',
        templateOptions: {
            options: [{
                label: 'Platform User',
                value: 'platform'
            }, {
                label: 'Tenant User',
                value: 'tenant'
            }],
            label: 'Account Type',
            placeholder: 'Select Account Type'
        }
    },
    {
        key: 'tenantId',
        type: 'select-component',
        className: 'col-md-4',
        hideExpression: "model.accounttype === 'platform'",
        templateOptions: {
            type: 'tenant',
            label: 'Tenant',
            placeholder: 'Select Tenant'
        }
    },
    {
        key: 'appId',
        type: 'select-component',
        className: 'col-md-4',
        hideExpression: "!model.tenantId",
        templateOptions: {
            type: 'app',
            parentFieldName: 'tenantId',
            label: 'App',
            placeholder: 'Select App'
        }
    },
    {
        key: 'role',
        type: 'select-component',
        className: 'col-md-4',
        templateOptions: {
            options: [{
                label: 'Tenant User',
                value: 'tenantuser'
            }, {
                label: 'Platform User',
                value: 'platformuser'
            },
            {
                label: 'Developer',
                value: 'developer'
            },
            {
                label: 'Administrator',
                value: 'administrator'
            }],
            label: 'Role',
            placeholder: 'Select Role'
        }
    },
    {
        key: 'applications',
        type: 'select-component',
        className: 'col-md-4',
        templateOptions: {
            options: [{
                label: 'Platform',
                value: 'sandbox.ampcome.com'
            }, {
                label: 'Partner Web App',
                value: 'sandboxweb.netlify.app'
            },
            {
                label: 'Mobile Web App',
                value: 'sandbox-eat.netlify.app'
            },
            {
                label: 'Customer Mobile App',
                value: 'com.gokhana.customer'
            },
            {
                label: 'Partner Mobile App',
                value: 'com.gokhana.restaurant'
            },
            {
                label: 'Foodcourt Mobile App',
                value: 'com.gokhana.foodcourt'
            }],
            multiple: true,
            label: 'Applications',
            placeholder: 'Select Applications'
        }
    },
    // {
    //     key: 'roleId',
    //     type: 'select-component',
    //     className: 'col-md-4',
    //     hideExpression: "model.accounttype !== 'app' || !model.appId ",
    //     templateOptions: {
    //         type: 'role',
    //         options: [],
    //         label: 'Role',
    //         placeholder: 'Select Role'
    //     }
    // }
];


export const newaccountfields: Array<FormlyFieldConfig> = [
    {
        key: 'email',
        className: 'col-sm-4',
        type: 'input',
        templateOptions: {
            type: 'email',
            placeholder: '',
            required: true,
            label: 'Email Address'
        }
    },
    {
        key: 'password',
        className: 'col-sm-4',
        type: 'input',
        templateOptions: {
            type: 'password',
            placeholder: '',
            required: true,
            label: 'Password'
        }
    },
    {
        key: 'role',
        className: 'col-sm-4',
        type: 'select',
        defaultValue: 'staff',
        templateOptions: {
            label: 'Select Role',
            options: [],
            required: true
        }
    },
    {
        key: 'accounttype',
        className: 'col-sm-6',
        type: 'input',
        hide: true,
        defaultValue: 'app'
    }
];

export const updateuserdata: Array<FormlyFieldConfig> = [
    {
        key: 'id',
        type: 'input',
        templateOptions: {
            type: 'hidden'
        }
    },
    {
        key: 'email',
        className: 'col-sm-4',
        type: 'input',
        defaultValue: '',
        templateOptions: {
            type: 'text',
            label: 'Email',
            disabled: true
        }
    },
    {
        key: 'role',
        className: 'col-sm-4',
        type: 'select',
        templateOptions: {
            label: 'Select Role',
            options: [],
            required: true
        }
    }
];

export const updateuserpassword: Array<FormlyFieldConfig> = [
    {
        key: 'id',
        type: 'input',
        templateOptions: {
            type: 'hidden'
        }
    },
    {
        key: 'password',
        className: 'col-sm-4',
        type: 'input',
        defaultValue: '',
        templateOptions: {
            type: 'password',
            label: 'New Password',
            required: true
        }
    },
    {
        key: 'confirmpassword',
        className: 'col-sm-4',
        type: 'input',
        defaultValue: '',
        templateOptions: {
            type: 'password',
            label: 'Confirm Password',
            required: true
        }
    }
];

export const infoFormFields: Array<FormlyFieldConfig> = [
    {
        key: 'email',
        type: 'input',
        templateOptions: {
            type: 'email',
            label: 'Email address',
            placeholder: 'Enter email',
            disabled: true
        },
        validation: Validators.compose([Validators.required, ValidationService.emailValidator])
    },
    {
        key: 'firstname',
        type: 'input',
        templateOptions: {
            type: 'text',
            label: 'First Name',
            required: true
        }

    },
    {
        key: 'lastname',
        type: 'input',
        templateOptions: {
            type: 'text',
            label: 'Last Name',
            required: true
        }

    },
    {
        key: 'phone',
        type: 'input',
        templateOptions: {
            type: 'text',
            label: 'Phone',
            required: true
        }

    },
    {
        key: 'address',
        type: 'textarea-field',
        templateOptions: {
            label: 'Address',
            required: false
        }
    },
    {
        key: 'city',
        type: 'input',
        templateOptions: {
            type: 'text',
            label: 'City',
            required: false
        }

    },
    {
        key: 'country',
        type: 'input',
        templateOptions: {
            type: 'text',
            label: 'Country',
            required: false
        }

    },
    {
        key: 'postalcode',
        type: 'input',
        templateOptions: {
            type: 'text',
            label: 'Zip/Postal Code',
            required: false
        }

    }
];


export const changePasswordFormFields: Array<FormlyFieldConfig> = [
    {
        key: 'currentpassword',
        type: 'input-field',
        className: 'col-md-4',
        templateOptions: {
            type: 'password',
            label: 'Current Password',
            placeholder: 'Current Password'
        },
        validation: Validators.compose([Validators.required])
    },
    {
        key: 'password',
        type: 'input-field',
        className: 'col-md-4',
        templateOptions: {
            type: 'password',
            label: 'Password',
            placeholder: 'Password'
        },
        validation: Validators.compose([Validators.required, Validators.maxLength(32), Validators.minLength(6)])
    },
    {
        key: 'confirmpassword',
        type: 'input-field',
        className: 'col-md-4',
        templateOptions: {
            type: 'password',
            label: 'Confirm Password',
            placeholder: 'Confirm Password'
        },
        validation: Validators.compose([Validators.required, Validators.maxLength(32), Validators.minLength(6)])
    }
];



// WEBPACK FOOTER //
// ./src/app/shared/formfields/account.ts